import {
    GET_ROLE_LIST_FAILED,
    GET_ROLE_LIST_REQUEST, GET_ROLE_LIST_SUCCESS
} from "../Actions/RoleAction";



const InitialState = {
    roles: [],
    loading: false,
};

export const RolesReducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case GET_ROLE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_ROLE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                roles: action.payload,
            };

        case GET_ROLE_LIST_FAILED:
            return {
                ...state,
                loading: false,
                roles: action.payload,
            };

        default:
            return state;
    }
};